import fp3d from "./img-04.jpg";
import fp2d from "./img-16.jpg";

const FLOOR_PLAN_KEYS = new Set(["./img-04.jpg", "./img-16.jpg"]);

const photoModules = import.meta.glob('./img-*.jpg', { eager: true, import: 'default' }) as Record<string, string>;

const sorted = Object.entries(photoModules)
  .filter(([key]) => !FLOOR_PLAN_KEYS.has(key))
  .sort(([a], [b]) => {
    const na = parseInt(a.match(/img-(\d+)/)?.[1] || "0");
    const nb = parseInt(b.match(/img-(\d+)/)?.[1] || "0");
    return na - nb;
  })
  .map(([, src]) => src);

export const kamykImages: string[] = sorted;

export const kamykFloorPlans: { image: string; label: string }[] = [
  { image: fp3d, label: "Půdorys – 3D vizualizace" },
  { image: fp2d, label: "Půdorys – 2D" },
];
